const styles = theme => ({
  content: {
    display: 'flex',
    margin: 'auto',
    padding: '20px 100px',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
    alignSelf: 'stretch',
    maxWidth: '840px',
  },
  button: {
    marginTop: '8px',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '260px',
    height: '260px',
    overflow: 'hidden',
  },
  previewImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
  header: {
    color: 'var(--mcg-blue, #015FFB)',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '150%',
  },
  text: {
    color: '#637381',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
  },
})

export default styles
